import React, { useState } from 'react'

function Star({ num = 0, onChange }: any) {
  const [arr] = useState([1, 2, 3, 4, 5])
  const [starNum, setStarNum] = useState(num)
  const changeStar = (idex: number) => {
    onChange(idex)
    setStarNum(idex)
  }
  return (
    <span>
      {arr.map((ele: any) => {
        return (
          <span key={ele} onClick={() => changeStar(ele)}>
            {ele > starNum ? (
              <i
                style={{ color: '#E8E8E8', fontSize: '0.3rem' }}
                className="iconfont"
              >
                &#xe641;
              </i>
            ) : (
              <i
                style={{ color: '#F39A02', fontSize: '0.3rem' }}
                className="iconfont"
              >
                &#xe641;
              </i>
            )}
          </span>
        )
      })}
    </span>
  )
}

export default Star
